﻿/**
 * Loáº¡i
 * bdanh 05.02.2023
 */
export default {
  /// <summary>
  /// A.CÁC CHỈ TIÊU CƠ SỞ TÍNH DỰ TOÁN
  /// </summary>
  TitleA: 1,

  /// <summary>
  /// B.TỔNG DỰ TOÁN CHI THƯỜNG XUYÊN
  /// </summary>
  TitleB: 2,

  /// <summary>
  /// Loại
  /// </summary>
  Kind: 5,
  /// <summary>
  /// Chương
  /// </summary>
  Chapter: 10,
  /// <summary>
  /// Khoản
  /// </summary>
  SubKind: 15,
  /// <summary>
  /// Nguồn
  /// </summary>
  Source: 20,
  /// <summary>
  /// Tiêu chí thống kê
  /// </summary>
  Criteria: 25,
  /// <summary>
  /// Nhiệm vụ
  /// </summary>
  Regular: 30,
};
